import React from "react";
import { UserDTO } from "../DTO/Userx";

interface DeleteDialogProps {
    visible: boolean;
    onHide: () => void;
    onDelete: () => void;
    user: UserDTO | null;
}

const DeleteDialog: React.FC<DeleteDialogProps> = ({ visible, onHide, onDelete, user }) => {
    if (!visible) return null;

    return (
        <div className="fixed inset-0 bg-ink/50 flex items-center justify-center z-50">
            <div className="bg-surface rounded shadow-md w-full max-w-md p-6 relative border border-border">
                <h2 className="text-2xl font-bold text-primary mb-2">Benutzer löschen</h2>
                <p className="text-text-secondary mb-4">
                    Möchtest du folgenden Benutzer wirklich löschen?
                </p>
                <div className="mb-6">
                    <p className="text-lg font-semibold text-on-surface">
                        {user?.firstName} {user?.lastName}
                    </p>
                    <p className="text-sm text-text-secondary">{user?.username}</p>
                </div>
                <div className="flex justify-end space-x-3">
                    <button
                        onClick={onHide}
                        className="px-4 py-2 rounded-md bg-border hover:bg-primary-variant text-on-surface transition-colors"
                    >
                        Abbrechen
                    </button>
                    <button
                        onClick={onDelete}
                        className="btn-danger"
                    >
                        Löschen
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteDialog;
